import * as CreditCard from "./credit_card"

const SDK_URL = "https://js.tappaysdk.com/sdk/tpdirect/v5.19.2"
const SDK_LOAD_TIMEOUT = 10000

// 付款方式設定
export const PAYMENT_METHODS = {
  CREDIT_CARD: "credit_card",
  LINE_PAY: "line_pay",
  JKO_PAY: "jko_pay"
}

// 非同步付款方式（需要跳轉）
const ASYNC_PAYMENT_CONFIG = {
  [PAYMENT_METHODS.LINE_PAY]: {
    sdkMethod: "linePay",
    errorMessage: "LINE Pay 付款失敗"
  },
  [PAYMENT_METHODS.JKO_PAY]: {
    sdkMethod: "jkoPay",
    errorMessage: "街口支付付款失敗"
  }
}

/**
 * 載入 TapPay SDK
 * @returns {Promise<void>}
 * @throws {Error} SDK 載入失敗時拋出錯誤
 */
export function loadSDK() {
  return new Promise((resolve, reject) => {
    if (window.TPDirect) {
      resolve()
      return
    }

    const script = document.createElement("script")
    script.src = SDK_URL

    const timeout = setTimeout(() => {
      reject(new Error("TapPay SDK 載入逾時"))
    }, SDK_LOAD_TIMEOUT)

    script.onload = () => {
      clearTimeout(timeout)
      resolve()
    }

    script.onerror = () => {
      clearTimeout(timeout)
      reject(new Error("TapPay SDK 載入失敗"))
    }

    document.head.appendChild(script)
  })
}

/**
 * 初始化 TapPay SDK
 */
export function setupSDK(appId, appKey, environment) {
  TPDirect.setupSDK(appId, appKey, environment)
}

/**
 * 取得非同步付款方式的 Prime（LINE Pay、街口支付等）
 * @param {string} method - 付款方式
 * @returns {Promise<string>} Prime token
 */
export function getAsyncPaymentPrime(method) {
  const config = ASYNC_PAYMENT_CONFIG[method]

  if (!config) {
    return Promise.reject(new Error("不支援的付款方式"))
  }

  return new Promise((resolve, reject) => {
    TPDirect[config.sdkMethod].getPrime((result) => {
      if (result.status !== 0) {
        reject(new Error(result.msg || config.errorMessage))
      } else {
        resolve(result.prime)
      }
    })
  })
}

// LINE Pay 模組
export const LinePay = {
  getPrime: () => getAsyncPaymentPrime(PAYMENT_METHODS.LINE_PAY)
}

// 街口支付模組
export const JkoPay = {
  getPrime: () => getAsyncPaymentPrime(PAYMENT_METHODS.JKO_PAY)
}

export { CreditCard }
